"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostCenterChartTypeEnum = void 0;
var CostCenterChartTypeEnum;
(function (CostCenterChartTypeEnum) {
    CostCenterChartTypeEnum["DETAIL_VIEW"] = "detailView";
    CostCenterChartTypeEnum["BUDGET_VIEW"] = "budgetView";
})(CostCenterChartTypeEnum || (exports.CostCenterChartTypeEnum = CostCenterChartTypeEnum = {}));
